import '../styles/App.css';
import ToursList from './ToursList';

function App() {
  return (
    <div className="App">
        <ToursList />
    </div>
  );
}

export default App;
